import { FMG_FORM_BLOCK_RECEIVE, FMG_FORM_BLOCK_ERROR } from './FMGFormBlock.action';
import { error as errorReducer } from '../../../Reducers/Error.reducer';

const defaultState = {
    result: []
}
export const FMGFormReducer = (state = defaultState, action) => {
    switch (action.type) {
        case FMG_FORM_BLOCK_RECEIVE:
            return {
                ...state,
                result: [...state.result, action.payload],
            }
        case FMG_FORM_BLOCK_ERROR:
            return {
                ...state,
                errors: errorReducer(state.errors, action)
            }
        default:
            return state;
    }
}